import { useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { SortOrder, listFiltersService, ListTableSort } from "sprint-common-web";

export interface DeliveryEndpointListingFilters {
    page: number;
    pageSize: number;
    sortBy: string;
    sortOrder: SortOrder;
}

const defaultFilters: DeliveryEndpointListingFilters = {
    page: 1,
    pageSize: 50,
    sortBy: "name",
    sortOrder: "asc"
};

export const useDeliveryEndpointListingFilters = () => {
    const filtersService = useMemo(() => listFiltersService<DeliveryEndpointListingFilters>(defaultFilters), []);
    const location = useLocation();
    const history = useHistory();

    const [filters, setFilters] = useState<DeliveryEndpointListingFilters>(() =>
        filtersService.getSavedFilters(location.search)
    );

    useEffect(() => {
        filtersService.saveFilters(location.pathname, history, filters);
    }, [location.pathname, history, filters]);

    const setSort = (sort: ListTableSort) => {
        setFilters((prevFilters: DeliveryEndpointListingFilters) => ({
            ...prevFilters,
            sortBy: sort.by,
            sortOrder: sort.order,
            page: 1
        }));
    };

    const setPage = (page: number) => {
        setFilters((prevFilters: DeliveryEndpointListingFilters) => ({ ...prevFilters, page }));
    };

    const setPageSize = (pageSize: number): void => {
        setFilters((prevFilters: DeliveryEndpointListingFilters) => ({ ...prevFilters, pageSize, page: 1 }));
    };

    return {
        filters,
        setPage,
        setPageSize,
        setSort
    };
};
